// The kit first: the application's own sheet refers to its tokens.
import '@easymusic/ui/fonts.css';
import '@easymusic/ui/styles.css';
import './index.css';
import './app/i18n';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { createStore } from './app/store';
import { APP_NAME } from './shared/lib/brand';
import { errorReporter } from './shared/lib/errorReporting';
import { loadSite } from './shared/lib/site';

document.title = APP_NAME;
// Loaded apart from the application, and only if the build names a tracker.
errorReporter.start();

const store = createStore();

// Which pages there are depends on where the parts of the installation are: asked
// once, before anything is shown (shared/lib/site.ts).
void loadSite().then(() =>
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App store={store} />
    </StrictMode>,
  ),
);
